export class EmptyAsNullValueConverter {
  toView(value) {
    return value === null ? '' : value;
  }

  fromView(value: string) {
    return typeof value === 'string' && value.trim() === '' ? null : value;
  }
}
